import React from "react";

/**
 * Purely presentational announcement banner.
 * Renders a magenta-tinted strip between the masquerade strip and the nav.
 * Returns null when announcement is null — no conditional wrapper needed at the call site.
 *
 * Props:
 *   announcement — { id, title, body?, cta_label?, cta_url? } | null
 *   onDismiss    — () => void
 */
export function AnnouncementBanner({ announcement, onDismiss }) {
  if (!announcement) return null;

  const { title, body, cta_label, cta_url, text_align = "left" } = announcement;
  const hasCta = Boolean(cta_label && cta_url);


  return (
    <div
      role="status"
      style={{
        background: "#FFF5FB",
        borderLeft: "4px solid #F90091",
        borderBottom: "1px solid rgba(249,0,145,0.13)",
        padding: "12px 20px",
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
      }}
    >
      {/* Ghost spacer — only needed for center to balance the dismiss button */}
      {text_align === "center" && <div style={{ width: 28, flexShrink: 0 }} />}

      <div style={{ flex: 1, minWidth: 0, textAlign: text_align }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#151515" }}>
          {title}
        </div>
        {body && (
          <div
            data-testid="announcement-body"
            style={{ fontSize: 13, color: "#3E3E3E", marginTop: 2 }}
          >
            {body}
          </div>
        )}
        {hasCta && (
          <div style={{ marginTop: 4 }}>
            <a
              href={cta_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 13, fontWeight: 600, color: "#F90091", textDecoration: "none" }}
            >
              {cta_label}
            </a>
          </div>
        )}
      </div>

      <button
        aria-label="Dismiss announcement"
        onClick={onDismiss}
        style={{
          width: 28,
          flexShrink: 0,
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: 16,
          lineHeight: 1,
          padding: 4,
          color: "#9A9A9A",
        }}
      >
        ✕
      </button>
    </div>
  );
}
